import HeaderBranding from './HeaderBranding';

export default HeaderBranding;
